/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import { useNavigate } from "react-router";
import Sprite from "app/components/sprite";
import classNames from "classnames";
import PropTypes from "prop-types";
import { createContext, useContext, useRef, useState } from "react";

export const AccordionContext = createContext({});
const useAccordion = () => useContext(AccordionContext);

export const Accordion = ({ children, active, scrollToDiv }) => {
  const [selected, setSelected] = useState(active);

  const togglePanel = (id) => {
    return setSelected((prevState) => (prevState !== id ? id : ""));
  };

  return (
    <AccordionContext.Provider value={{ selected, scrollToDiv, togglePanel }}>
      {children}
    </AccordionContext.Provider>
  );
};

export const AccordionItem = ({
  id,
  className,
  upBtn = "circle-caret-up",
  downBtn = "circle-caret-up",
  btnClassName = "w-6 h-6",
  children,
}) => {
  const { selected, scrollToDiv, togglePanel } = useAccordion();
  const navigate = useNavigate();

  const updateUrlFragment = () => {
    if (selected !== id) {
      setTimeout(() => {
        navigate({ hash: id }, { preventScrollReset: true });
      }, 150);
    }
  };

  return (
    <div
      id={id}
      role="button"
      onClick={() => {
        togglePanel(id);
        scrollToDiv && updateUrlFragment();
      }}
      className={classNames("scroll-mt-16", className)}
    >
      {children}
      <div className="flex items-center">
        <Sprite
          name={id === selected ? upBtn : downBtn}
          className={btnClassName}
        />
      </div>
    </div>
  );
};

export const AccordionPanel = ({ id, className, children }) => {
  const ref = useRef();
  const { selected } = useAccordion();

  return (
    <div
      ref={ref}
      className={classNames(
        "overflow-hidden md:overflow-x-hidden transition-all ease duration-150",
        className
      )}
      style={
        selected === id
          ? { height: ref.current?.scrollHeight }
          : { height: "0px" }
      }
    >
      {children}
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.string,
  scrollToDiv: PropTypes.bool,
};
AccordionItem.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  upBtn: PropTypes.string,
  downBtn: PropTypes.string,
  btnClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
};
AccordionPanel.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};
